export const str2bool = (value) => {
  if ([false, true].includes(value)) return value;

  if (value === 'true') return true;

  if (value === 'false') return false;

  return undefined;
};

export const normalizeStr = (value, sep = '') => {
  if (value == null) return '';

  // lowercase
  let s = String(value).toLowerCase();

  // split accents (NFKD) and remove combining marks
  s = s.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');

  // collapse anything not a-z or 0-9 to the separator
  s = s.replace(/[^a-z0-9]+/g, sep);

  // trim the separator from both ends (if sep is non-empty)
  if (sep) {
    const esc = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    s = s.replace(new RegExp(`^(?:${esc})+|(?:${esc})+$`, 'g'), '');
  }

  return s;
};
